"use client";

import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";

/**
 * Root-level error boundary. Catches errors that escape all other error
 * boundaries, including root layout errors. Reports to Datadog RUM
 * (note: error message is sanitized in production by Next.js).
 *
 * Delete or customize once a proper error UI is designed.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    datadogRum.addError(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ padding: 40, fontFamily: "system-ui, sans-serif" }}>
          <h1>Something went wrong</h1>
          <p>An unexpected error occurred. The team has been notified.</p>
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: 16,
              padding: "8px 16px",
              fontSize: 14,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
